module.exports = __webpack_public_path__ + "img/reviewing-zhant.9999d029.png";